module.exports = __webpack_public_path__ + "media/images/favicon/mstile-310x150-a8b5d7b0fee75e6abeeb8b9b1a920de2.png";